import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Workflow from './Workflow'
import BootstrapAlert from '../element/BootstrapAlert'
import ErrorBoundary from '../ErrorBoundary'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: '0px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

function getApproversArray (workflow) {
  const levelMap = workflow.all_approvers
    .reduce((m, current, i, src) => {
      if (!m.has(current.level)) {
        m.set(current.level, [])
      }
      current.user.isApproved = current.is_approved
      m.get(current.level).push(current.user)
      return m
    }, new Map())
  return Array.from(levelMap.keys()).sort().map((key) => levelMap.get(key))
}

function getApproverInfo (workflow, myselfId) {
  // 現在の承認者に自分が含まれるときのみチェック情報を返す
  if (workflow.all_approvers.find(
    (approver) => approver.level === workflow.current_level && approver.sp_user_id === myselfId
  )) {
    return {
      level: workflow.current_level,
      userIdToCheck: myselfId
    }
  } else {
    return null
  }
}

export default function WorkflowEditor (props) {
  const classes = useStyles()
  const approversArray = useRef(getApproversArray(props.workflow, props.myself))
  const approverInfo = useRef(getApproverInfo(props.workflow, props.myself.id))
  const [invalidMessage, setInvalidMessage] = useState([])
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    document.getElementById(props.submitModalButtonId)?.addEventListener('click', () => setModalOpen(true))
  }, [props.submitModalButtonId])

  return (
    <>
      <BootstrapAlert class="primary">
        <>
          <h4>注意事項</h4>
          <ul>
            <li>この承認ルートで既に承認や差し戻しを行ったアカウントは、このルートからは削除できません。</li>
            <li>承認済みアカウントが最終承認者となるような変更はできません。</li>
            <li><b>必ず管理メンバーを承認ルートに追加してください。</b></li>
            <li>並列承認の設定が可能です：一度に複数の承認者を設定できます。誰か1名が承認すれば次レベルの承認者に申請が回ります。</li>
          </ul>
        </>
      </BootstrapAlert>
      <div className="row mt-3">
        <div className="col-4 text-center">
          {
            Workflow(
              props.generalUsers,
              props.managers,
              approversArray.current,
              'ライセンシー',
              false,
              props.allowGeneralsOnly,
              null,
              setInvalidMessage,
              approverInfo.current
            )
          }
        </div>
        <div className="col-8">
        </div>
      </div>
      {/* ---- 設定確認モーダル ---- */}
      <Modal
        className={classes.modal}
        open={modalOpen}
        onClose={() => setModalOpen(false)}>
        <div className={classes.paper}>
        {invalidMessage
          ? (
              <>
                <h2>承認ルート設定エラー</h2>
                <hr/>
                <BootstrapAlert class='danger'>
                  <div>{invalidMessage}</div>
                </BootstrapAlert>
              </>
            )
          : (
              <>
                <h2>承認ルート変更確認</h2>
                <hr/>
                <ul className='my-3'>
                  <li>承認ルートを変更します。</li>
                  <li>承認は行わず、この後に申請を修正できます。</li>
                </ul>
              </>
            )
            }
          <hr />
          <div className="row">
            <div className="col-6">
              <button type='button' className='btn btn-secondary' onClick={() => setModalOpen(false)}>
                キャンセル
              </button>
            </div>
            <div className="col-6 text-right">
              {!invalidMessage && (
                <button type='submit' form={props.formId} className='btn bg-8'>
                  承認ルート変更
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

WorkflowEditor.propTypes = {
  myself: PropTypes.object,
  generalUsers: PropTypes.arrayOf(PropTypes.object),
  managers: PropTypes.arrayOf(PropTypes.object),
  workflow: PropTypes.object,
  allowGeneralsOnly: PropTypes.bool,
  submitModalButtonId: PropTypes.string,
  formId: PropTypes.string
}

WorkflowEditor.defaultProps = {
  allowGeneralsOnly: false,
  submitModalButtonId: 'submit-modal',
  formId: 'main-form'
}

$('#workflow-editor').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WorkflowEditor {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
